import React from 'react';
import { useForm } from 'react-hook-form';
import { connect, useDispatch, useSelector } from 'react-redux';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { actualizacionContrasenia, resetOlvido } from '../../actions/olvido_contrasenia/envioContraseniaTemporal';

import { hideAlert, showAlert } from '../../actions/alertMessage';
import AlertaMessage from '../AlertaMessage';
import { MensajesAlertas } from '../../models/MensajesAlertas';
import { useNavigate } from 'react-router-dom';
import { validPassword, evaluarPassword, REGLAS_PASSWORD } from '../../helpers/methodValidate';


const FormActContrasenia = (props) => {

    const { closeModal } = props;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const obtencionAlerta = useSelector((state) => state.alertMessage);
    const user = useSelector((state) => state.auth);
    const { statusPass} = user;
    const datosOlvido = useSelector((state) => state.OlvidoContrasenia);
    const { email, contraseniaTemporal: temporalGuardada } = datosOlvido.dataOlvido;
    const solicitarTemporal = !temporalGuardada;

    const validateOlvido = Yup.object({
        contraseniaTemporal: solicitarTemporal
                        ? Yup.string().required('El campo es requerido')
                        : Yup.string().notRequired(),
        nuevaContrasenia: Yup.string().required('El campo es requerido')
                        .test('validPassword', "Ingrese una contraseña correcta", (value) => validPassword(value)),
        confirmarContrasenia: Yup.string().required('El campo es requerido')
                        .oneOf([Yup.ref('nuevaContrasenia'), null], 'La confirmación de contraseña no coincide'),
    });

    const { register, handleSubmit, watch, formState: { errors, isValid } } = useForm({
        resolver: yupResolver(validateOlvido),
        mode: "onChange" 
    });

    const nuevaContraseniaActual = watch('nuevaContrasenia', '');
    const cumplimiento = evaluarPassword(nuevaContraseniaActual);

    const modalExito = () => { 
        dispatch(showAlert(MensajesAlertas.mensajeSuccessOlvidoContrasenia, 
            () => { 
                closeModal(); 
                navigate("/login");
            },
            "",
            undefined,
            () => { closeModal(); navigate("/login"); }
        ));
    }

    const onSubmit = (data) => {
        const { contraseniaTemporal, nuevaContrasenia, confirmarContrasenia } = data;
        const temporal = solicitarTemporal ? contraseniaTemporal : temporalGuardada;
        dispatch(actualizacionContrasenia(email, temporal, nuevaContrasenia, confirmarContrasenia))
        .then((res) => {
            if(res !== "ERROR_SERVICIO") {
                modalExito();
            }
        });
    }


    return (
        <Card className="card-login" >
            <Card.Body>
                <Card.Title className='fs-3'>Actualiza tu contraseña</Card.Title>
                {
                    (statusPass === 0) && <>
                        <Card.Text className='mb-3'>Hemos enviado un correo con una nueva contraseña a correo@atria.com</Card.Text>
                        <Card.Text className='mb-3'>Si no recibiste el mensaje, por favor revisa tu carpeta de correo no deseado</Card.Text>
                    </>
                }
                
                <Form onSubmit={handleSubmit(onSubmit)} noValidate >
                    <Row>
                        {/*<Col xs={12} >
                            <AlertError textoError={"Mensaje error"}  />
                        </Col>*/}
                        {solicitarTemporal && (
                        <Form.Group as={Col} xs="12" className='mb-3'>
                            <Form.Label>Contraseña Temporal</Form.Label>
                            <Form.Control 
                                type="password" 
                                name="contraseniaTemporal" 
                                placeholder="Ingresa tu contraseña temporal"
                                maxLength={16}
                                autoComplete="off"
                                className={`${errors.contraseniaTemporal ? 'is-invalid' : ""}`}
                                {...register('contraseniaTemporal')} 
                            />
                            <p className='texto-error'>{errors.contraseniaTemporal?.message}</p>
                        </Form.Group>
                        )}

                        <Form.Group as={Col} xs="12" className='mb-3'>
                            <Form.Label>Nueva Contraseña</Form.Label>
                            <Form.Control 
                                type="password" 
                                name="nuevaContrasenia" 
                                placeholder="Ingresa tu nueva contraseña"
                                maxLength={100}
                                autoComplete="off"
                                className={`${errors.nuevaContrasenia ? 'is-invalid' : ""}`}
                                {...register('nuevaContrasenia', { required: "El campo es requerido" })} 
                            />
                            <p className='texto-error'>{errors.nuevaContrasenia?.message}</p>
                        </Form.Group>
                        
                        <Col xs={12} className='mb-3' >
                            <ul className='list-group lista-requisitos-password'>
                                {REGLAS_PASSWORD.map(({ clave, texto }) => (
                                    <li key={clave} className={cumplimiento[clave] ? 'requisito-cumplido' : 'requisito-pendiente'}>
                                        {texto}
                                    </li>
                                ))}
                            </ul>
                        </Col>
                        

                        <Form.Group as={Col} xs="12" className='mb-3'>
                            <Form.Label>Confirmar Contraseña</Form.Label>
                            <Form.Control 
                                type="password" 
                                name="confirmarContrasenia" 
                                placeholder="Ingresa nuevamente tu contraseña"
                                maxLength={100}
                                autoComplete="off"
                                className={`${errors.confirmarContrasenia ? 'is-invalid' : ""}`}
                                {...register('confirmarContrasenia', { required: "El campo es requerido" })} 
                            />
                            <p className='texto-error'>{errors.confirmarContrasenia?.message}</p>
                        </Form.Group>

                        
                        
                        <Form.Group as={Col} xs="12" className="mt-4 ms-auto" >
                            <Button type="submit" className="btn btn-primary w-100" disabled={!isValid} >Actualizar contraseña</Button>
                        </Form.Group>
                    </Row>
                </Form>
            </Card.Body>
            <AlertaMessage show={obtencionAlerta.show} data={obtencionAlerta.data} />
        </Card>
    )
}


const mapDispatchToProps = dispatch => {
	return {
        closeModal: () => {
            dispatch(hideAlert());
            dispatch(resetOlvido());
        }
	};
};

export default connect(null, mapDispatchToProps)(FormActContrasenia)